import React from "react";
import classes from "../Homescreen/Homescreen.module.css";

function Events() {
  return (
    <div className={classes.mainscreen_display}>
      <h1>Coming soon!</h1>
    </div>
  );
}

export default Events;
